import { Container, BorderColor, Icon, Spacer, Text, TextColor } from 'roadie-ui'

type IconType = 'warning' | 'error' | 'success' | 'info'

type Variant = {
  Icon: typeof Icon.Info
  iconColor: TextColor
  backgroundColor: BorderColor
}

const variants: Record<IconType, Variant> = {
  info: {
    Icon: Icon.Info,
    iconColor: 'secondary-base',
    backgroundColor: 'secondary-lighter',
  },
  error: {
    Icon: Icon.AlertFilled,
    iconColor: 'error-base',
    backgroundColor: 'error-lighter',
  },
  success: {
    Icon: Icon.AlertFilled,
    iconColor: 'success-base',
    backgroundColor: 'success-lighter',
  },
  warning: {
    Icon: Icon.AlertFilled,
    iconColor: 'alert-base',
    backgroundColor: 'alert-lighter',
  },
}

type SectionMessageProps = {
  description: string
  iconType: IconType
  maxWidth?: string
  title?: string
  border?: boolean
}

export default function SectionMessage({
  description,
  iconType,
  maxWidth = '100%',
  title,
  border = true,
}: SectionMessageProps) {
  const { Icon: MessageIcon, iconColor, backgroundColor } = variants[iconType]

  return (
    <Container.Grid
      $borderWidth={border ? '1px' : '0'}
      $borderStyle="solid"
      $borderColor={backgroundColor}
      $alignItems="center"
      $gridTemplateColumns="5rem 1fr"
      $maxWidth={maxWidth}
      $borderRadius=".4rem"
    >
      <Container.GridItemGrid
        $backgroundColor={border ? backgroundColor : undefined}
        $height="100%"
        $justifyContent="center"
        $alignItems="center"
        $borderRadius=".4rem 0 0 .4rem"
      >
        <MessageIcon $width="2.4rem" $height="2.4rem" $color={iconColor} />
      </Container.GridItemGrid>
      <Container.GridItem $padding="1.6rem">
        {title && (
          <>
            <Text.Subtitle1 $color="neutral-black" $textAlign="left">
              {title}
            </Text.Subtitle1>
            <Spacer $height="0.4rem" />
          </>
        )}
        <Text.Body2 $color="neutral-darker" $textAlign="left">
          {description}
        </Text.Body2>
      </Container.GridItem>
    </Container.Grid>
  )
}
